import { Article } from '@/mocks/articles';
import { articleImages } from '@/mocks/articleImages';

interface ArticleContentProps {
  article: Article;
}

export default function ArticleContent({ article }: ArticleContentProps) {
  const mainImage = articleImages[article.imageSeq] || articleImages['article-01'];

  return (
    <article className="py-8 md:py-12">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="mb-6">
          <div className="flex items-center gap-2 mb-4 flex-wrap">
            <span className="text-xs text-primary-600 font-medium bg-primary-100 px-2.5 py-1 rounded">
              {article.categoryName}
            </span>
            {article.isHot && (
              <span className="text-xs text-accent-600 font-medium bg-accent-100 px-2.5 py-1 rounded flex items-center gap-0.5">
                <i className="ri-fire-line text-[10px]"></i>热门
              </span>
            )}
            {article.isTop && (
              <span className="text-xs text-secondary-600 font-medium bg-secondary-100 px-2.5 py-1 rounded flex items-center gap-0.5">
                <i className="ri-pushpin-line text-[10px]"></i>置顶
              </span>
            )}
          </div>

          <h1 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 leading-tight mb-4">
            {article.title}
          </h1>

          <div className="flex flex-wrap items-center gap-4 text-sm text-foreground-500 mb-6">
            <span className="flex items-center gap-1.5">
              <i className="ri-user-line"></i>
              {article.authorName}
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-calendar-line"></i>
              {article.publishDate}
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-eye-line"></i>
              {article.viewCount > 10000
                ? `${(article.viewCount / 10000).toFixed(1)}万阅读`
                : `${article.viewCount}阅读`}
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-chat-3-line"></i>
              {article.commentCount > 10000
                ? `${(article.commentCount / 10000).toFixed(1)}万评论`
                : `${article.commentCount}评论`}
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-time-line"></i>
              {article.readTime}分钟阅读
            </span>
          </div>
        </div>

        <div className="aspect-[16/9] rounded-2xl overflow-hidden mb-8">
          <img
            src={mainImage}
            alt={article.title}
            className="w-full h-full object-cover object-top"
            title={`今日看料 - ${article.title}`}
          />
        </div>

        <div
          className="prose prose-sm md:prose-base max-w-none text-foreground-800 leading-relaxed
            prose-p:mb-5 prose-p:leading-relaxed
            prose-strong:text-foreground-950 prose-strong:font-semibold
            [&_strong]:text-foreground-950 [&_strong]:font-semibold"
          dangerouslySetInnerHTML={{ __html: article.content }}
        />

        <div className="mt-8 pt-6 border-t border-background-200/70">
          <div className="flex flex-wrap items-center gap-2">
            <span className="text-xs text-foreground-500 mr-1">标签：</span>
            {article.tags.map((tag) => (
              <span
                key={tag}
                className="text-xs text-foreground-600 bg-background-100 px-3 py-1 rounded-full"
              >
                #{tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </article>
  );
}